import React, {Component} from 'react';
import {Segment, List, Icon} from 'semantic-ui-react';

export default class Bills extends Component {

    render() {

        const bills = [
            {
                "id": "0",
                "payee": "Cable",
                "due": "Due in 5 days",
                "amt": 98,
                "acctNum": "4390580"
            },
            {
                "id": "1",
                "payee": "Electric",
                "due": "Due in 10 days",
                "amt": 70,
                "acctNum": "800234405"
            }
        ];

        return (
            <Segment.Group className='hooli-segment'>
                <Segment className='hooli-segment-top'>
                    <List>
                        <List.Item>
                            <List.Content floated='right'>
                                <a><Icon name='add' className='hooli-btn-segment' /> Track a Bill</a>
                            </List.Content>
                            <List.Header><h3 className='hooli-text-dark-blue'>BILLS</h3></List.Header>
                        </List.Item>
                    </List>
                </Segment>
                {bills.map(bill => (
                    <Segment key={bill.id}>
                        <List>
                            <List.Item>
                                <div className='hooli-text-grey hooli-text-light hooli-list-spacing'>{bill.payee}</div>
                                <List.Content floated='right'>
                                    <div className='hooli-text-grey hooli-text-light'>${bill.amt}</div>
                                </List.Content>
                                <List.Header>{bill.due}</List.Header>
                                <div className='hooli-text-grey hooli-text-light hooli-list-spacing'>{bill.acctNum}</div>
                            </List.Item>
                        </List>
                    </Segment>
                ))}
                <Segment className='hooli-segment-bottom'/>
            </Segment.Group>
        )

    }

}
